import React, { useEffect, useState } from "react";
import Stripe from "stripe";
import getPublishableKey from '../../stripe/publishableKey';
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";

const stripe_publishable_key = getPublishableKey()
// const stripe_secret_key = getSecretKey()
const stripePromise = loadStripe(stripe_publishable_key)
// const stripe = Stripe(stripe_secret_key)

const Dashboard = (props) => {
    const {planName, cancelarSuscripcion, conectarStripe, isStripeUser, conectandoStripe, balance} = props;
        
    useEffect(() => {
        console.log('isStripeUser', isStripeUser)
    }, [isStripeUser]);
    return (
        <div className="dashboard">
            {
                !isStripeUser &&
                    <div className="dashboard-top-plan stripe-connect-content gap-3">

                        <p>Conecta su cuenta con <b>Stripe</b> para poder recibir pagos. {isStripeUser}</p>
                        <btn  className="btn login-boton" onClick={conectarStripe}>
                            { conectandoStripe ? 'Conectando...' : 'Conectar' }
                        </btn>
                    </div>
            }
            <div className="dashboard-body">
                <div className="dashboard-top-plan gap-3">
                    <p>Actualmente dispone del <b>{planName}</b>.</p>
                    <button className="btn btn-danger" onClick={cancelarSuscripcion}>Cancelar suscripción</button>
                </div>
            </div>
            {
                isStripeUser && balance && 
                <div className="dashboard-content-top d-flex justify-content-end">
                    <p class="balance">
                        {balance} €
                    </p>
                </div>
            }
        </div>
    );
}

export default Dashboard;